// Merkezi site yapılandırması.
// Tüm iletişim, adres, sosyal medya ve NAP (Name-Address-Phone) bilgileri
// tek kaynaktan yönetilir. Bileşenler bu sabitleri import ederek kullanır.

const PHONE_RAW = "+905538036475"; // tel: ve schema için
const PHONE_DISPLAY = "0553 803 64 75"; // ekranda gösterim
const WHATSAPP_NUMBER = "905538036475"; // wa.me için (başında 0 ve + olmadan)

export const SITE = {
  name: "Üç Kardeşler Teknik Servis",
  shortName: "Üç Kardeşler",
  legalName: "Üç Kardeşler Teknik Servis",
  url: "https://www.uckardeslerteknikservis.com",

  // İletişim
  phone: PHONE_RAW,
  phoneDisplay: PHONE_DISPLAY,
  phoneHref: `tel:${PHONE_RAW}`,
  email: "uckardeslerteknikservis@outlook.com",
  emailHref: "mailto:uckardeslerteknikservis@outlook.com",

  // WhatsApp
  whatsappNumber: WHATSAPP_NUMBER,
  whatsapp: `https://wa.me/${WHATSAPP_NUMBER}`,
  whatsappMessage: (text) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      text || "Merhaba, teknik servis hizmeti hakkında bilgi almak istiyorum."
    )}`,

  // Adres / konum
  address: {
    full: "Çiftehavuzlar Mahallesi Uslu Sokak No:82A, Osmangazi, Bursa",
    street: "Çiftehavuzlar Mahallesi Uslu Sokak No:82A",
    district: "Osmangazi",
    city: "Bursa",
    region: "Bursa",
    postalCode: "16200",
    country: "TR",
  },
  geo: {
    lat: 40.209953,
    lng: 29.052999,
  },

  // Çalışma saatleri
  workingHours: "7/24 Teknik Servis",

  // Hizmet verilen bölgeler (local SEO)
  serviceAreas: [
    "Osmangazi",
    "Nilüfer",
    "Yıldırım",
    "Gürsu",
    "Kestel",
    "Mudanya",
    "Özlüce",
    "Beşevler",
    "Görükle",
    "Demirtaş",
  ],

  // Sosyal medya
  social: {
    instagram:
      "https://www.instagram.com/uckardesler_teknikservis/?igshid=YTQwZjQ0NmI0OA%3D%3D",
    facebook:
      "https://www.facebook.com/people/%C3%9C%C3%A7karde%C5%9Fler-teknik-servis/100094923730332/?mibextid=LQQJ4d",
  },
};

// Google Maps yardımcıları
export const MAPS = {
  directionsUrl: `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    SITE.address.full
  )}`,
  embedSrc: `https://maps.google.com/maps?q=${encodeURIComponent(
    SITE.address.full
  )}&hl=tr&z=17&output=embed`,
};

export default SITE;
